module.exports = "table {\n    width: 100%;\n}"